import { MAINTENANCE_DISABLED } from '@shared/utils/constant'
import { Page } from '@/types'

export default defineNuxtRouteMiddleware((to) => {
  const $pinia = usePinia()
  const jsonStore = useSharedJsonStore($pinia)

  const isMaintenanceMode = !MAINTENANCE_DISABLED && jsonStore.isMaintenanceMode

  if (isMaintenanceMode && to.name !== Page.Maintenance) {
    return navigateTo({ name: Page.Maintenance })
  }

  if (!isMaintenanceMode && to.name === Page.Maintenance) {
    return navigateTo({ name: Page.Index })
  }
})
